module.exports = __webpack_public_path__ + "./static/img/review.53393f37e462b0989a03d0df4dce6114.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/img/welcome/review.png
// module id = ./client/src/assets/img/welcome/review.png
// module chunks = 0